<template>
<div id="rcs-action">
  <div class="loader overlay" v-if="loader">
    <img class="overlay-container" src="@/assets/img/loader.gif" />
  </div>
  <div v-else class="row">
    <div class="large-12 medium-12 small-12 columns"><p></p>
      <div>
        <div>
          <h2 v-html="title" />
          <hr class="top" />
          <div v-html="result" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
  name: "RCSAction",
  data () {
    return {
      title: '',
      result: '',
      loader: true
    }
  },
  created: function() { 
    const that = this;
    axios.post('/pb/easy-api/message/activate', that.$route.query).then((res) => {
      this.title = res.data.title;
      this.result = res.data.result;
    })
    .catch((e) => {
      this.title = "Chyba aktivácie";
      this.result = "<span class='magenta'>Počas odosielania požiadavky sa vyskytla chyba. Skúste znova.</span>";
    })
    .then(() => {
      if (!_.isEmpty(that.$route.query)) {
        that.$router.replace({ query: {} });
      }
      this.loader = false;      
    })
  },

  mounted: function() {
  }
}
</script>

